export default __webpack_public_path__ + "452a3cc982f8478c22cd8dbb3afbb54c.svg";